import { makeStyles, css } from '@conexasaude/conexa-hero'

import noise from '@/assets/noise.png'

const useStyles = makeStyles({
  container: ({ colors, spacing }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    min-height: calc(100vh - 60px);
    padding: 0 ${spacing.xs};
    background: linear-gradient(
      252.46deg,
      ${colors.brand.primary[400]} 0%,
      ${colors.brand.primary[500]} 100%
    );
    background-size: 400% 400%;
    animation: gradient 10s ease infinite;

    @media screen and (max-height: 760px) {
      min-height: 100vh;
    }

    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  `,
  changePasswordNoise: css`
    position: absolute;
    background-image: url(${noise});
    background-position: center;
    background-size: cover;
    height: calc(100vh - 72px);
    width: 100%;
    @media screen and (max-height: 760px) {
      min-height: 100vh;
    }
  `,
  timeZoneSection: ({ colors, spacing, fontSizes }) => css`
    bottom: 40px;
    position: fixed;
    margin: 0 ${spacing.xs} 0 ${spacing.xs};
    @media screen and (max-height: 760px) {
      position: relative;
      bottom: 0px;
    }
    p {
      font-size: ${fontSizes.xs};
      color: ${colors.neutral[300]};
      margin-top: ${spacing.xxs};
      @media screen and (max-width: 768px) {
        text-align: center;
      }
    }
  `,
})

export default useStyles
